import { ExamInterface, ExerciseDataType } from "../../interfaces/examInterfaces";
import { Group } from "../../interfaces/topicInterfaces";

//Objective 1
//Niveau 1
import imgObjective_1_Level_1_Exercise_1 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_01_6_H.png";
import imgObjective_1_Level_1_Exercise_1_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_01_6_H_L.png";

import imgObjective_1_Level_1_Exercise_2 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_02_6_H.png";
import imgObjective_1_Level_1_Exercise_2_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_02_6_H_L.png";

import imgObjective_1_Level_1_Exercise_3 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_03_4_H_25.png";
import imgObjective_1_Level_1_Exercise_3_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_03_4_H_L.png";

import imgObjective_1_Level_1_Exercise_4 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_04_6_H_25.png";
import imgObjective_1_Level_1_Exercise_4_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_04_6_H_L.png";

import imgObjective_1_Level_1_Exercise_5 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_05_3_H_25.png";
import imgObjective_1_Level_1_Exercise_5_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_1_05_3_H_L.png";

//Niveau 2
import imgObjective_1_Level_2_Exercise_1 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_2_01_2_H.png";
import imgObjective_1_Level_2_Exercise_1_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_2_01_2_H_L.png";

import imgObjective_1_Level_2_Exercise_2 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_2_02_2_H.png";
import imgObjective_1_Level_2_Exercise_2_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_2_02_2_H_L.png";

import imgObjective_1_Level_2_Exercise_3 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_2_03_2_H_25.png";
import imgObjective_1_Level_2_Exercise_3_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_2_03_2_H_L.png";

//Niveau 3
import imgObjective_1_Level_3_Exercise_1 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_3_01_2_H.png";
import imgObjective_1_Level_3_Exercise_1_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_3_01_2_H_L.png";

import imgObjective_1_Level_3_Exercise_2 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_3_02_2_H.png";
import imgObjective_1_Level_3_Exercise_2_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_3_02_2_H_L.png";

import imgObjective_1_Level_3_Exercise_3 from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_3_03_2_H_25.png";
import imgObjective_1_Level_3_Exercise_3_solution from "./assets/imagesDemo/6_1_1_Brueche/1/6_1_1_1_3_03_2_H_L.png";

//Objective 2
//Niveau 1
import imgObjective_2_Level_1_Exercise_1 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_01_4_H.png";
import imgObjective_2_Level_1_Exercise_1_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_01_4_H_L.png";

import imgObjective_2_Level_1_Exercise_2 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_02_4_H.png";
import imgObjective_2_Level_1_Exercise_2_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_02_4_H_L.png";

import imgObjective_2_Level_1_Exercise_3 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_03_4_H.png";
import imgObjective_2_Level_1_Exercise_3_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_03_4_H_L.png";

import imgObjective_2_Level_1_Exercise_4 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_04_4_H.png";
import imgObjective_2_Level_1_Exercise_4_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_04_4_H_L.png";

import imgObjective_2_Level_1_Exercise_5 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_05_4_H_25.png";
import imgObjective_2_Level_1_Exercise_5_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_05_4_H_L.png";

import imgObjective_2_Level_1_Exercise_6 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_06_4_H_25.png";
import imgObjective_2_Level_1_Exercise_6_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_1_06_4_H_L.png";


// Niveau 2
import imgObjective_2_Level_2_Exercise_1 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_2_01_2_H_25.png";
import imgObjective_2_Level_2_Exercise_1_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_2_01_2_H_L.png";


// Niveau 3
import imgObjective_2_Level_3_Exercise_1 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_3_01_2_H.png";
import imgObjective_2_Level_3_Exercise_1_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_3_01_2_H_L.png";

import imgObjective_2_Level_3_Exercise_2 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_3_02_2_H.png";
import imgObjective_2_Level_3_Exercise_2_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_3_02_2_H_L.png";

import imgObjective_2_Level_3_Exercise_3 from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_3_03_2_H_25.png";
import imgObjective_2_Level_3_Exercise_3_Solution from "./assets/imagesDemo/6_1_1_Brueche/2/6_1_1_2_3_03_2_H_L.png";


export const DEMO_DATA_SECOND_OBJECTIVE: ExerciseDataType[] = [
  {
    name: "Niveau 1",
    exercises: [
      {
        id: "6112101",
        imagePath: imgObjective_2_Level_1_Exercise_1,
        imagePathSolution: imgObjective_2_Level_1_Exercise_1_Solution,
        level: 1,
        newUntil: 1720994400,
        points: 4,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112102",
        imagePath: imgObjective_2_Level_1_Exercise_2,
        imagePathSolution: imgObjective_2_Level_1_Exercise_2_Solution,
        level: 1,
        newUntil: 1720994400,
        points: 4,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112103",
        imagePath: imgObjective_2_Level_1_Exercise_3,
        imagePathSolution: imgObjective_2_Level_1_Exercise_3_Solution,
        level: 1,
        newUntil: 1720994400,
        points: 4,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112104",
        imagePath: imgObjective_2_Level_1_Exercise_4,
        imagePathSolution: imgObjective_2_Level_1_Exercise_4_Solution,
        level: 1,
        newUntil: 1720994400,
        points: 4,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112105",
        imagePath: imgObjective_2_Level_1_Exercise_5,
        imagePathSolution: imgObjective_2_Level_1_Exercise_5_Solution,
        level: 1,
        newUntil: 1784066400,
        points: 4,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112106",
        imagePath: imgObjective_2_Level_1_Exercise_6,
        imagePathSolution: imgObjective_2_Level_1_Exercise_6_Solution,
        level: 1,
        newUntil: 1784066400,
        points: 4,
        index: 0,
        showRocket: false,
      },
    ],
  },
  {
    name: "Niveau 2",
    exercises: [
      {
        id: "6112201",
        imagePath: imgObjective_2_Level_2_Exercise_1,
        imagePathSolution: imgObjective_2_Level_2_Exercise_1_Solution,
        level: 2,
        newUntil: 1784066400,
        points: 2,
        index: 0,
        showRocket: false,
      },
    ],
  },
  {
    name: "Niveau 3",
    exercises: [
      {
        id: "6112301",
        imagePath: imgObjective_2_Level_3_Exercise_1,
        imagePathSolution: imgObjective_2_Level_3_Exercise_1_Solution,
        level: 3,
        newUntil: 1720994400,
        points: 2,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112302",
        imagePath: imgObjective_2_Level_3_Exercise_2,
        imagePathSolution: imgObjective_2_Level_3_Exercise_2_Solution,
        level: 3,
        newUntil: 1720994400,
        points: 2,
        index: 0,
        showRocket: false,
      },
      {
        id: "6112303",
        imagePath: imgObjective_2_Level_3_Exercise_3,
        imagePathSolution: imgObjective_2_Level_3_Exercise_3_Solution,
        level: 3,
        newUntil: 1784066400,
        points: 2,
        index: 0,
        showRocket: false,
      },
    ],
  },
];

export const DEMO_EXAM_DATA: ExamInterface = {
  grade: 6,
  id: "1",
  name: "Meine Prüfung",
  objectives: {
    6111: {
      exercises: {},
      id: "6111",
      objective:
        "Ich kann einen Bruch mit dem Kreismodell, dem Streckenmodell und dem Rechteckmodell benennen, darstellen und vergleichen.",
      objectiveIndex: 1,
      topic: "6.1.1 Brüche",
    },
    6112: {
      exercises: {},
      id: "6112",
      objective: "Ich kann den Anteil einer Zahl oder einer Grösse bestimmen.",
      objectiveIndex: 2,
      topic: "6.1.1 Brüche",
    },
  },
};

export const DEMO_TOPIC_DATA: Group[] = [
  {
    id: "61",
    group: "Zahl und Variable",
    topics: [
      {
        id: "611",
        topic: "6.1.1 Brüche",
        objectives: [
          {
            id: "6111",
            objective:
              "Ich kann einen Bruch mit dem Kreismodell, dem Rechteckmodell benennen, darstellen und vergleichen.",
          },
          {
            id: "6112",
            objective: "Ich kann den Anteil einer Zahl oder einer Grösse bestimmen.",
          },
        ],
      },
    ],
  },
];

export const DEMO_DATA_FIRST_OBJECTIVE: ExerciseDataType[] = [
  {
    name: "Niveau 1",
    exercises: [
      {
        id: "6111101",
        imagePath: imgObjective_1_Level_1_Exercise_1,
        imagePathSolution: imgObjective_1_Level_1_Exercise_1_solution,
        level: 1,
        newUntil: 1720994400,
        points: 6,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111102",
        imagePath: imgObjective_1_Level_1_Exercise_2,
        imagePathSolution: imgObjective_1_Level_1_Exercise_2_solution,
        level: 1,
        newUntil: 1720994400,
        points: 6,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111103",
        imagePath: imgObjective_1_Level_1_Exercise_3,
        imagePathSolution: imgObjective_1_Level_1_Exercise_3_solution,
        level: 1,
        newUntil: 2099426400,
        points: 4,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111104",
        imagePath: imgObjective_1_Level_1_Exercise_4,
        imagePathSolution: imgObjective_1_Level_1_Exercise_4_solution,
        level: 1,
        newUntil: 2099426400,
        points: 6,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111105",
        imagePath: imgObjective_1_Level_1_Exercise_5,
        imagePathSolution: imgObjective_1_Level_1_Exercise_5_solution,
        level: 1,
        newUntil: 2099426400,
        points: 3,
        index: 0,
        showRocket: false,
      },
    ],
  },
  {
    name: "Niveau 2",
    exercises: [
      {
        id: "6111201",
        imagePath: imgObjective_1_Level_2_Exercise_1,
        imagePathSolution: imgObjective_1_Level_2_Exercise_1_solution,
        level: 2,
        newUntil: 1720994400,
        points: 2,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111202",
        imagePath: imgObjective_1_Level_2_Exercise_2,
        imagePathSolution: imgObjective_1_Level_2_Exercise_2_solution,
        level: 2,
        newUntil: 1720994400,
        points: 2,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111203",
        imagePath: imgObjective_1_Level_2_Exercise_3,
        imagePathSolution: imgObjective_1_Level_2_Exercise_3_solution,
        level: 2,
        newUntil: 2099426400,
        points: 2,
        index: 0,
        showRocket: false,
      },
    ],
  },
  {
    name: "Niveau 3",
    exercises: [
      {
        id: "6111301",
        imagePath: imgObjective_1_Level_3_Exercise_1,
        imagePathSolution: imgObjective_1_Level_3_Exercise_1_solution,
        level: 3,
        newUntil: 1720994400,
        points: 2,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111302",
        imagePath: imgObjective_1_Level_3_Exercise_2,
        imagePathSolution: imgObjective_1_Level_3_Exercise_2_solution,
        level: 3,
        newUntil: 1720994400,
        points: 2,
        index: 0,
        showRocket: false,
      },
      {
        id: "6111303",
        imagePath: imgObjective_1_Level_3_Exercise_3,
        imagePathSolution: imgObjective_1_Level_3_Exercise_3_solution,
        level: 3,
        newUntil: 2099426400,
        points: 2,
        index: 0,
        showRocket: false,
      },
    ],
  },
];
